export default __webpack_public_path__ + "0dd0819bcca88c0c8d93bc9d3c76ecea.png";